mutation updateProject($input: UpdateProjectInput!) {
  updateProject(input: $input)
}
